const getCookie = (cname) => {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}


const getCookieSpecial = (cname) => {
	return document.cookie
		.split('; ')
		.map(cookie => cookie.split('='))
		.reduce((acc, [key, value]) => ({ ...acc, [key]: decodeURIComponent(value) }), {})[cname];
}


export {
	getCookie,
	getCookieSpecial
}